// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"7bd20921","191":"79041a74","217":"b3d9330d","461":"b72f76af","507":"468b360b","634":"7bd20921","699":"b72f76af","973":"05ae1b4a","992":"7bd20921"}[chunkId] + ".chunk.css";
};